import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { Box, Flex } from 'styled-system/jsx';

interface PerformanceModalProps {
  open: boolean;
  closeModal: () => void;
  title: string;
  description: string;
}

export default function PerformanceModal({
  open,
  closeModal,
  title,
  description,
}: PerformanceModalProps) {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <Flex alignItems="center" marginBottom="16px" gap="8px">
        <Box
          width="4px"
          height="22px"
          backgroundColor="#8553CB"
          borderRadius="10px"
        />
        <Typography textStyle="b1" color="black-1">
          {title}
        </Typography>
        <CloseIcon onClick={closeModal} />
      </Flex>

      <Box
        padding="16px"
        backgroundColor="white"
        borderRadius="8px"
        position="relative"
        width="100%"
        maxWidth="400px"
      >
        <Typography
          textAlign="right"
          color="black-1"
          textStyle="b2"
          fontWeight="500"
          whiteSpace="pre-line"
          dir="rtl"
        >
          {description}
        </Typography>
      </Box>

      <Box marginTop="24px">
        <Button fullWidth onClick={closeModal}>
          متوجه شدم
        </Button>
      </Box>
    </MainModal>
  );
}
